import type { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type Props = ComponentProps<"div"> & {
  /**
   * Columns from `md` up; below that the cells stack. `3` is two columns at
   * `md` and three from `xl`.
   */
  cols?: 1 | 2 | 3;
};

/**
 * A grid of outlined cards side by side, separated by a 12px gap. Each cell
 * is its own card (a `Surface` or `SectionCard`), never a cell in a shared
 * outline.
 */
export const CardGrid: FC<Props> = ({ cols = 1, className, ...props }) => (
  <div
    {...props}
    className={cn(
      "grid grid-cols-1 gap-3",
      cols >= 2 && "md:grid-cols-2",
      cols === 3 && "xl:grid-cols-3",
      // A cell that spans the row whatever the column count.
      "[&>[data-span=full]]:md:col-span-2",
      cols === 3 && "[&>[data-span=full]]:xl:col-span-3",
      className
    )}
  />
);
